import { Component, h, Prop } from '@stencil/core';

@Component({
	tag: 'kdx-text-callout',
	styleUrl: 'kdx-text-callout.scss',
	shadow: false,
})
export class KdxTextCallout {

	@Prop() heading: string;
	@Prop() ctaPrimaryText: string;
	@Prop() ctaPrimaryHref: string;
	@Prop() ctaPrimaryAriaLabel: string;
	@Prop() ctaPrimaryTarget: string;
	@Prop() isSpeedbump: boolean;
	@Prop() orientation: string = "center-aligned"; // left-aligned or center-aligned

	render() {
		return (
		<div class={`kdx-text-callout ${this.orientation}`}>
			<div class="container-fluid">
				<div class="col-lg-8 offset-lg-2">

					{Boolean(this.heading) && (
						<h2 class="kdx-text-callout__heading">{ this.heading }</h2>
					)}

					<div class="kdx-text-callout__content">
						<slot />
					</div>

					{Boolean(this.ctaPrimaryHref) && (
						<div class="kdx-text-callout__action">
							<a class={`btn btn-primary ${this.isSpeedbump ? 'speedbump-link' : ''}`}
								href={this.ctaPrimaryHref}
								target={this.ctaPrimaryTarget}
								aria-label={this.ctaPrimaryAriaLabel ?? this.ctaPrimaryText}>
								{ this.ctaPrimaryText }
							</a>
						</div>
					)}

				</div>
			</div>
		</div>
		);
	}

}
